class operationService {
    constructor($http, $location, $q, logger, httpRequest, $rootScope) {
        this.$http = $http
        this.$location = $location
        this.logger = logger
        this.httpRequest = httpRequest
        this.$rootScope = $rootScope
        this.$q = $q
        // 結構化對象
        this.structureDate = null
        // 菜单对象
        this.$rootScope.subNavData = null
        this.$rootScope.functionTree = null
        this.$rootScope.functionObj = null
        // 权限改变状态
        // $rootScope.$on("permissionsChanged",operationService.init);
    }

    generatePageRightList(root) {
        const { functionList } = root
        const { userType } = root.userInfo.user
        // 所有账号都有的权限
        let pageList = [
            'index.list',
            'index.changeInitPw',
            'index.menuset',
            'message.list',
            'message.detail',
            'message.center',
            'workspace.list',
            'workspace.item',
            'workspace.item.detail',
            'workspace.item.opened',
            'workspace.item.bill',
            'workspace.item.redinfo',
            'workspace.blue',
            'workspace.item.management',
            'workspace.item.vehicle',
            'workspace.item.reiburseInfo',
            'workspace.item.reopenVehicleApprove',
            'workspace.item.roll',
            'outputManage.FOManage.eleInvoice.printView',
            'system.settingcenter.externalSystem.add',
            'system.settingcenter.externalSystem.edit',
            'input.reimburseManage.deduction.testpdf',
            'creditLine.list',
            'certification.list',
            'outputManage.fullElectricInvoice.fullEleInvoice.realEstateDetail',
            'outputManage.fullElectricInvoice.fullEleInvoice.constructionDetail',
            'outputManage.fullElectricInvoice.fullEleInvoice.detail',
            'outputManage.invoicePool.outputInvoicePool.tax4Detail',
            'outputManage.invoicePool.outputInvoicePool.realEstateDetail',
            'outputManage.invoicePool.outputInvoicePool.constructionDetail',
            'outputManage.invoicePool.outputInvoicePool.tax3Detail',
            'outputManage.fullElectricInvoice.openedFullEleInvoice.detail',
            'outputManage.fullElectricInvoice.fullEleInvoice.edit',
            'input.invoicePool.inputInvoicePool.tax3Detail',
            'input.invoicePool.inputInvoicePool.tax4Detail',
            'input.invoicePool.inputInvoicePool.collectRecord',
            'system.basedata.taxAccount.lockRecordList',
        ]
        if (userType == 0) {
            pageList.push('initStep', 'initStep.initStepOne', 'initStep.initStepTwo', 'initStep.initStepThree', 'initStep.initStepFour', 'license')
        }
        if (IS_PROVIDER) pageList = ['help.list', 'help.changeInitPw', 'help.initChangePW']
        functionList.forEach((functionItem) => {
            if (functionItem.url) {
                pageList.push(functionItem.url)
            }
            if (functionItem.remark) {
                pageList = pageList.concat(functionItem.remark.split(','))
            }
        })
        return pageList
    }

    /**
     * 初始化权限、菜单
     * @param  {object} loginInfo {accessToken, functionList, loginInfo}
     */
    init() {
        this.$rootScope.functionList = JSON.parse(localStorage.getItem('function_list'))
        this.$rootScope.userInfo = JSON.parse(localStorage.getItem('user_info'))

        if (this.$rootScope.userInfo && !this.$rootScope.loginOrgList) {
            this.httpRequest.get_getUserOrgListByUserId(this.$rootScope.userInfo.user.userId, this.$rootScope.userInfo.user.userType).then((res) => {
                this.$rootScope.loginOrgList = res.data.value
            })
        }
        const functionListLength = this.$rootScope.functionList.length
        if (!functionListLength) {
            return false
        }
        // 根据functionlist 生成页面权限列表
        this.$rootScope.pageList = this.generatePageRightList(this.$rootScope)
        //localStorage.setItem('page_list', JSON.stringify(this.generatePageRightList(this.$rootScope)))
        // 当销方不存在，则不显示金税盘管理模块(注释掉 ---> 改为页面中提示)
        // if (this.$rootScope.userInfo.sale === null) {
        //     for (let i = 0; i < functionListLength - 1; i++) {
        //         if (this.$rootScope.functionList[i].treeLevelCode === '0_2_90_93') {
        //             this.$rootScope.functionList.splice(i, 1)
        //         }
        //     }
        // }
        this.$rootScope.functionTree = this.structure(this.$rootScope.functionList)
        // 扩展菜单树，添加当前默认路由
        this.$rootScope.functionTree = this.$rootScope.functionTree.map((item) => {
            const defaultRouter = {}
            if (item.childFuncList !== null && item.childFuncList[0].childFuncList !== null) {
                defaultRouter.defaultUrl = item.childFuncList[0].childFuncList[0].url
            }
            return $.extend({}, defaultRouter, item)
        })
        this.structureDate = this.$rootScope.functionTree
        if (NEED_INDEX) {
            const { userType } = JSON.parse(localStorage.user_info).user
            if (userType !== 0 && userType !== 10) {
                this.structureDate.unshift({
                    functionId: 507,
                    functionName: '首页',
                    url: 'index.list',
                    treeLevelCode: '0_507',
                    parentFunctionId: -1,
                    defaultUrl: 'index.list',
                })
            }
        }
        this.$rootScope.subNavData = this.$rootScope.functionTree[0].childFuncList
        this.cache()
        return this.structureDate
    }

    structure(list) {
        // 适配树组件数据结构
        function recursion(data, pid) {
            const result = []
            let temp
            for (const i in data) {
                if (data[i].parentFunctionId == pid) {
                    result.push(data[i])
                    temp = recursion(data, data[i].functionId)
                    if (temp.length > 0) {
                        data[i].childFuncList = temp
                    }
                }
            }
            return result
        }
        return recursion(list, -1)
    }

    cache() {
        //localStorage.setItem('function_tree', JSON.stringify(this.structureDate))
        localStorage.setItem('function_list', JSON.stringify(this.$rootScope.functionList))
    }

    // 获取菜单权限
    getFunctions() {
        const deferred = this.$q.defer()
        let functionTree = this.structure(JSON.parse(localStorage.getItem('function_list')))
        //const functionTree = localStorage.getItem('function_tree')

        if (!this.structureDate) {
            return this.init()
        }
        functionTree = functionTree.map((item) => {
            const defaultRouter = {}
            if (item.childFuncList !== null && item.childFuncList[0].childFuncList !== null) {
                defaultRouter.defaultUrl = item.childFuncList[0].childFuncList[0].url
            }
            return $.extend({}, defaultRouter, item)
        })
        this.$rootScope.functionTree = this.structureDate = functionTree
        this.$rootScope.subNavData = this.$rootScope.functionTree[0].childFuncList
        deferred.resolve(this.structureDate)

        return deferred.promise
    }

    // 是否具备按钮权限
    hasPermit(functionCode) {
        if (!this.structureDate) return
        this.functionObj = this.$rootScope.functionObj
        if (!this.functionObj) {
            this.functionObj = {}
            this.function_list = JSON.parse(localStorage.getItem('function_list'))
            this.function_list.forEach((ele) => {
                this.functionObj[ele.functionCode] = true
            })
            this.$rootScope.functionObj = this.functionObj
        }
        // this.function_list = this.$rootScope.functionList
        // if (!this.function_list) {
        //     this.function_list = JSON.parse(localStorage.getItem('function_list'))
        //     this.function_list.forEach((ele) => {
        //         this.functionObj[ele.functionCode] = true
        //     })
        // }

        const functionCodeArr = functionCode.split(',')
        let allow = false
        // 改造权限写法
        // @auther <sujingjun&&13682603870@163.com>
        if (functionCodeArr.length === 0) {
            return allow
        }

        allow = functionCodeArr.some((ele) => {
            return this.functionObj[ele]
        })

        // for (const i in this.function_list) {
        //   if (
        //     functionCodeArr.indexOf(this.function_list[i].functionCode) > -1 &&
        //     this.function_list[i].functionCode != 'have_a_look'
        //   ) {
        //     // have_a_look  查看按钮不显示,只为只读权限设置
        //     allow = true
        //     break
        //   }
        // }
        return allow
    }

    destroy() {
        //localStorage.removeItem('function_tree')
        localStorage.removeItem('function_list')
        this.$rootScope.functionTree = null
        this.$rootScope.functionList = null
        this.$rootScope.functionObj = null
        this.structureDate = null
    }
}

operationService.$inject = ['$http', '$location', '$q', 'logger', 'httpRequest', '$rootScope']
export default operationService



// WEBPACK FOOTER //
// ./src/common/services/operationService.js